import type { FC } from 'react';

import { ClickableDiv } from '@wwe-portal/ui/components/button';
import { type OfferCardProps } from '@wwe-portal/ui/features/offer';
import { OfferItems } from '@wwe-portal/ui/features/offer/offer-card/offer-items';
import { cn } from '@wwe-portal/ui/lib/lib';

interface ExclusiveOfferBannerProps extends OfferCardProps {
  className?: string;
  isMobile?: boolean;
}
export const ExclusiveOfferBanner: FC<ExclusiveOfferBannerProps> = ({
  backgroundImage,
  title,
  items,
  style,
  onClick,
  className,
  isMobile = false,
}) => {
  return (
    <ClickableDiv
      className={cn(
        'font-poppins relative h-12 w-full cursor-default md:h-40',
        className
      )}
      onClick={onClick}
      role="none"
      style={style}
    >
      <div className="absolute inset-0 overflow-clip">
        <img
          alt={title ?? 'Offer Plan Background'}
          className="h-full w-full object-fill"
          src={backgroundImage}
        />
      </div>
      <div
        className={cn('absolute inset-x-0', {
          'inset-y-[19%]': !isMobile,
          'top-[-19%] h-full': isMobile,
        })}
      >
        <div className="absolute inset-x-0 bottom-2 top-4">
          {items != null && items.length > 0 && (
            <OfferItems
              isHiddenQuantity={isMobile}
              itemWidth="calc(5600%/348)"
              items={items}
              maxItem={3}
            />
          )}
        </div>
      </div>
    </ClickableDiv>
  );
};
